// extracted by mini-css-extract-plugin
export default {"component":"o7+5d"};